'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _css = require('antd/lib/table/style/css');

var _table = require('antd/lib/table');

var _table2 = _interopRequireDefault(_table);

var _css2 = require('antd/lib/button/style/css');

var _button = require('antd/lib/button');

var _button2 = _interopRequireDefault(_button);

var _css3 = require('antd/lib/message/style/css');

var _message = require('antd/lib/message');

var _message2 = _interopRequireDefault(_message);

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactRouter = require('react-router');

var _axios = require('axios');

var _axios2 = _interopRequireDefault(_axios);

var _constants = require('../constants');

var _level_form = require('./level_form');

var _level_form2 = _interopRequireDefault(_level_form);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var LevelList = _react2.default.createClass({
    displayName: 'LevelList',

    propTypes: {
        levels: _react.PropTypes.object.isRequired
    },
    render: function render() {
        var columns = [{
            title: '等级编号',
            key: 'id',
            dataIndex: 'id'
        }, {
            title: '等级名称',
            key: 'key',
            dataIndex: 'key'
        }, {
            title: '折扣',
            key: 'discount',
            dataIndex: 'discount'
        }, {
            title: '创建时间',
            key: 'created_at',
            dataIndex: 'created_at'
        }, {
            title: '操作',
            key: 'action',
            render: function render(text, record) {
                return _react2.default.createElement(
                    'div',
                    null,
                    _react2.default.createElement(_level_form2.default, { level: record, title: '\u7F16\u8F91\u5BA2\u6237\u7B49\u7EA7', btnText: '\u7F16\u8F91' }),
                    _react2.default.createElement(
                        _button2.default,
                        { onClick: function onClick() {
                                _axios2.default.delete(record.id).then(function () {
                                    return _message2.default.info('操作成功');
                                }).catch(function (error) {
                                    return _message2.default.error('\u64CD\u4F5C\u5931\u8D25\uFF1A' + error.data);
                                });
                            } },
                        '\u5220\u9664'
                    )
                );
            }
        }];

        var levels = this.props.levels;
        var items = levels.items,
            error = levels.error,
            isFetching = levels.isFetching;

        var pagination = Object.assign(_constants.PaginationConfig, {
            total: this.props.levels.items.length,
            onChange: function onChange(current, pageSize) {
                // pageSize是undefined，有待研究

            },
            onShowSizeChange: function onShowSizeChange(current, pageSize) {

            }
        });
        var tableConfig = {
            columns: columns,
            locale: { emptyText: error && !error.ok ? '\u7F51\u7EDC\u9519\u8BEF\uFF1A' + error.statusText : '暂无数据' },
            dataSource: items,
            loading: isFetching,
            pagination: pagination,
            rowKey: function rowKey(record) {
                return record.id;
            }
        };

        return _react2.default.createElement(_table2.default, tableConfig);
    }
});

exports.default = LevelList;


//////////////////
// WEBPACK FOOTER
// ./src/js/components/level_list.js
// module id = 1336
// module chunks = 0